import Footer from '../../components/Footer';
import About from '../../components/About';
import PageHeader from '../../components/PageHeader';
import { useTranslation } from 'react-i18next';
import NavbarNew from '../../components/NavbarNew';

function AboutPage() {
  const { t } = useTranslation();
  return (
    <>
      <div id="top">
        {/* <Preloader /> */}
        {/* /Preloader ends */}
        <NavbarNew />
        <PageHeader
          title={`PawFriends Sarajevo`}
          page={t('nav.about')}
          pageUrl={'about'}
        />
        {/* ==== Page Content ==== */}
        <div class="page">
          <About />
        </div>
        {/* /page */}
        <Footer />
      </div>
    </>
  );
}

export default AboutPage;
